import React from "react"
import VehicleMovementFilter from "../VehicleMovementList/VehicleMovementFilter"

const MovementKeyFilter = ({
  movementTypesData,
  employeesData,
  locationsData,
  params,
  updateParams,
  optionLoading,
}) => {
  return (
    <VehicleMovementFilter
      filters={params}
      setFilters={updateParams}
      movementTypes={movementTypesData?.map(item => ({
        label: item?.name,
        value: item?.id,
      }))}
      movementByOptions={employeesData?.map(item => ({
        label: item?.name,
        value: item?.id,
      }))}
      locationOptions={locationsData?.map(item => ({
        label: item?.name,
        value: item?.id,
      }))}
      loading={optionLoading}
    />
  )
}

export default MovementKeyFilter
